var handler = null;
var onLoaded = null;
var stripeLoading = false;
var stripeLoaded = false;

const CannyLogo = 'https://canny.io/images/d804731bb57d28a3528356d1ebb04a6d.jpg';
const StripeKey = __DEV__ ? 'pk_test_QdkCWFRIz1Ew9fjCPhlYspkj' : 'pk_live_vYNYos5vTI9MrxewiKBDXT6C';

const StripeManager = {
  closeStripe: function () {
    if (!handler) {
      return;
    }

    handler.close();
  },

  loadStripe: function () {
    if (stripeLoading || stripeLoaded) {
      return;
    }

    stripeLoading = true;

    var script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', 'https://checkout.stripe.com/checkout.js');
    script.onload = StripeManager.onStripeLoaded;

    var head = document.getElementsByTagName('head').item(0);
    head.appendChild(script);
  },

  onStripeClosed: function (callback) {
    handler = null;
    callback();
  },

  onStripeLoaded: function () {
    stripeLoading = false;
    stripeLoaded = true;

    if (onLoaded) {
      StripeManager.updateCard(onLoaded.email, onLoaded.callback);
    }
  },

  onStripeToken: function (token, callback) {
    handler = null;
    callback(null, token.id);
  },

  updateCard: function (email, callback) {
    if (!stripeLoaded) {
      onLoaded = {
        callback,
        email,
      };
      return;
    }

    handler = window.StripeCheckout.configure({
      billingAddress: true,
      closed: () => {
        StripeManager.onStripeClosed(callback);
      },
      image: CannyLogo,
      key: StripeKey,
      locale: 'auto',
      token: (token) => {
        StripeManager.onStripeToken(token, callback);
      },
    });
    handler.open({
      email,
      name: 'Canny',
      panelLabel: 'Update Card',
    });
  },
};

export default StripeManager;
